export default __webpack_public_path__ + "static/media/inventory-purchase.9430c0f8.jpg";